'use strict';

var _themeSections = require('@shopify/theme-sections');

require('venobox');

var _Sliders = require('scripts/components/Sliders');

// Vendor Plugins
var dom = {
  venobox: '[venobox]'
};
// Components
// Shopify Packages


(0, _themeSections.register)('testimonials', {
  onLoad: function onLoad() {
    this.$container = $(this.container);
    this.namespace = '.' + this.id;
    this.$venobox = this.$container.find(dom.venobox);
    this.init();
  },
  onUnload: function onUnload() {
    this.$container.off(this.namespace);
  },
  init: function init() {
    var _this = this;

    document.addEventListener('DOMContentLoaded', function () {
      (0, _Sliders.initSlider)('testimonials');
      _this.$venobox.venobox();
    });
  }
});

(0, _themeSections.load)('testimonials');